export default "__VITE_ASSET__BrZa67Rg__"